import React, { ReactNode } from 'react';

interface PageHeroProps {
  tag?: string;
  title: string;
  lead?: string;
  children?: ReactNode; 
}

export default function PageHero({ tag, title, lead, children }: PageHeroProps) {
  return (
    <div className="bg-navy pt-24 md:pt-32 pb-10 md:pb-16">
      <div className="container">
        {children}
        {tag && <span className="section-tag mb-4 inline-block">{tag}</span>}
        <h1
          className="font-syne text-white font-bold mb-3"
          style={{ fontSize: 'clamp(1.7rem, 4vw, 3rem)' }}
        >
          {title}
        </h1>
        {lead && <p className="text-silver text-sm max-w-lg leading-relaxed">{lead}</p>}
      </div>
    </div>
  );
}
